var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "flight-status" };
var _hoisted_2 = ["disabled"];
import InputField from '../InputField/InputField.vue';
import DatePicker from '../DatePicker/DatePicker.vue';
import AirportLookup from '../AirportLookup/AirportLookup.vue';
import { computed, inject, ref } from 'vue';
import dayjs from 'dayjs';
import AmadeusFormSubmission from '../AmadeusFormSubmission/AmadeusFormSubmission.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FlightStatus',
    props: {
        buttonText: {
            type: String,
            default: '',
        },
    },
    setup: function (__props) {
        var _a, _b;
        var props = __props;
        var aiportFrom = ref();
        var aiportTo = ref();
        var inputErrors = ref({});
        var FLIGHT_NUMBER = ref('');
        var TRIP_DATE = ref('');
        var onValueUpdated = function (e) {
            TRIP_DATE.value = new Date(e).toLocaleDateString('en-CA');
        };
        var disableSubmitBtn = computed(function () {
            return (FLIGHT_NUMBER.value.length < 1 ||
                TRIP_DATE.value.length < 1 ||
                aiportTo.value === undefined ||
                aiportFrom.value === undefined);
        });
        var amadeusParams = (_a = inject('amadeus-params')) !== null && _a !== void 0 ? _a : {};
        var statusParams = (_b = inject('amadeus-status-params')) !== null && _b !== void 0 ? _b : {};
        var params = computed(function () {
            var _a, _b, _c;
            var params = {
                FLIGHT_NUMBER: (_a = FLIGHT_NUMBER.value) === null || _a === void 0 ? void 0 : _a.replace(/kq/i, ''),
                B_DATE: dayjs(TRIP_DATE.value).format('YYYYMMDD') + '0000',
                B_LOCATION_1: (_b = aiportFrom.value) === null || _b === void 0 ? void 0 : _b.locIATA,
                E_LOCATION_1: (_c = aiportTo.value) === null || _c === void 0 ? void 0 : _c.locIATA,
                UI_EMBEDDED_TRANSACTION: 'FlightStatusPopUp',
                EXTERNAL_ID: 'FLIFO',
            };
            params = __assign(__assign(__assign({}, params), amadeusParams), statusParams);
            return params;
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _renderSlot(_ctx.$slots, "default"),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(AirportLookup, {
                        "airport-from": aiportFrom.value,
                        "onUpdate:airportFrom": _cache[0] || (_cache[0] = function ($event) { return ((aiportFrom).value = $event); }),
                        "airport-to": aiportTo.value,
                        "onUpdate:airportTo": _cache[1] || (_cache[1] = function ($event) { return ((aiportTo).value = $event); })
                    }, null, 8 /* PROPS */, ["airport-from", "airport-to"]),
                    _createVNode(InputField, {
                        modelValue: FLIGHT_NUMBER.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((FLIGHT_NUMBER).value = $event); }),
                        name: "FLIGHT_NUMBER",
                        placeholder: "Flight no, e.g. KQ600",
                        "additional-classes": "input-field m-t--16",
                        error: inputErrors.value
                    }, null, 8 /* PROPS */, ["modelValue", "error"]),
                    _createVNode(DatePicker, {
                        "min-date": _unref(dayjs)().subtract(1, 'day').toDate(),
                        "default-value": [],
                        name: "DEPARTURE_DATE",
                        placeholder: "Departure date",
                        label: "Departure date",
                        "onUpdate:date": onValueUpdated
                    }, null, 8 /* PROPS */, ["min-date"]),
                    _createVNode(AmadeusFormSubmission, { params: params.value }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("button", {
                                class: "button button--primary manage-booking__button",
                                type: "submit",
                                disabled: disableSubmitBtn.value
                            }, _toDisplayString(__props.buttonText), 9 /* TEXT, PROPS */, _hoisted_2)
                        ]; }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["params"])
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
